import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroModule } from '../../shared/NG-Zorro-Antd/ng-zorro-antd.module';
import { FacebookPostsComponent } from './Components/facebook-posts/facebook-posts.component';
import { FacebookRoutingModule } from './facebook-routing.module';
import { FacebookService } from './Services/facebook.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FacebookPostDetailsComponent } from './Components/facebook-post-details/facebook-post-details.component';
import { FacebookCommentsComponent } from './Components/facebook-comments/facebook-comments.component';



@NgModule({
  declarations: [
    FacebookPostsComponent,
    FacebookPostDetailsComponent,
    FacebookCommentsComponent,
  ],
  providers: [
    FacebookService,
  ],
  imports: [
    CommonModule,
    NgZorroModule,
    FacebookRoutingModule,
    FontAwesomeModule,
  ]
})
export class FacebookModule { }